import React from 'react'
import * as S from './styled'

const Home = () => {
  return <S.Home>
    <h2>Pesquise aqui um usuário do Github e tenha acesso às suas informações públicas.</h2>
  </S.Home>

}

export default Home
